module.exports = __webpack_public_path__ + "src/assets/img/trailer_12.27ccd3d0.svg";